<template>
  <div class="main-container shadow-s h-shadow-m h-m-button mh-60" v-if="url" @click="goToPage()">
    <img class="url-icon mh-40 hover-scale" alt="Presentation icon" src="@/assets/Presentation.svg" />
    <a class="link" target="_blank" rel="noopener noreferrer" :href="url">
      {{ $t('shared.presentationTile.text') }}
    </a>
  </div>
</template>

<script>
import config from '../../config'

export default {
  name: 'IntranetPresentationTile',
  computed: {
    url() {
      return config.INTRANET_PRESENTATION_URL
    }

  },
  methods: {
    goToPage() {
      location.href = this.url
    }
  }
}
</script>

<style scoped lang="scss">

.main-container {
  margin: 0 0 1rem 0;
  max-width: 280px;
  background-color: rgba(255,255,255,0.4);
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 10px;

  @media (max-width: $medium) {
    margin-left: 0;
    max-width: calc(100% - 20px) ;
    width: auto;
    margin-right: 0;
  }
  @media (max-width: $header-change) {
    width: 100%;
  }
}

.url-icon {
  width: 4em;
  height: auto;
  margin-right: 1em;
}
</style>
